<!-- <div class="site-detail-charts-button-area"> -->
<div class="w-full">
  <div class="w-full flex justify-end gap-4">
    <button
      mat-raised-button
      color="primary"
      class="site-detail-charts-button"
      (click)="onClickDaytimeCharts()"
      [disabled]="daytimeButtonDisabled"
    >
      日中
    </button>
    <button
      mat-raised-button
      color="primary"
      class="site-detail-charts-button"
      (click)="onClick1DayCharts()"
      [disabled]="dayButtonDisabled"
    >
      24時間
    </button>
    <button
      mat-raised-button
      color="primary"
      class="site-detail-charts-button"
      (click)="onClick1WeekCharts()"
      [disabled]="weekButtonDisabled"
    >
      1週間
    </button>
    <button
      mat-raised-button
      color="primary"
      class="site-detail-charts-button"
      (click)="onClick1MonthCharts()"
      [disabled]="monthButtonDisabled"
    >
      1ヶ月
    </button>
  </div>
</div>

<div class="w-full mt-8">
  <div class="w-full flex tilt-chart-flex">
    <div
      class="w-full tilt-chart-flex__item"
      *ngFor="let latestData of sensorData.tilt"
    >
      <mat-card>
        <mat-card-header>
          <mat-card-title>山留変位(mm)</mat-card-title>
        </mat-card-header>
        <app-tilt-line-chart
          [data]="latestData"
          [chartRange]="chartRange"
        ></app-tilt-line-chart>
      </mat-card>
    </div>
  </div>
</div>
